module.exports = __webpack_public_path__ + "img/vertical-screen-text.d1f89d5c.png";